import { GiroWebappError } from 'model/error';
import { IncomeStatement, IncomeStatementFilter } from 'model/income-statement';
import { action } from 'typesafe-actions';
import { GetMonthlyIncomeStatementTypes } from './types';

export const getMonthlyIncomeStatementRequest = (request: IncomeStatementFilter) => action(GetMonthlyIncomeStatementTypes.GET_MONTHLY_INCOME_STATEMENT_REQUEST, request);
export const getMonthlyIncomeStatementSuccess = (response: IncomeStatement) => action(GetMonthlyIncomeStatementTypes.GET_MONTHLY_INCOME_STATEMENT_SUCCESS, response);
export const getMonthlyIncomeStatementError = (error: GiroWebappError) => action(GetMonthlyIncomeStatementTypes.GET_MONTHLY_INCOME_STATEMENT_ERROR, error);
export const getMonthlyIncomeStatementResetState = () => action(GetMonthlyIncomeStatementTypes.GET_MONTHLY_INCOME_STATEMENT_RESET_STATE);
